export interface GenerateCodeRequest {
  OtpType: GenerateCodeTypes;
  seed: string;
}

export enum GenerateCodeTypes {
  CreateTransferRequest = 'CreateTransferRequest',
  UpdateTransferRequest = 'UpdateTransferRequest',
}
